import React, {useEffect} from 'react';

import {
    Stack,
} from '@mui/material';

import {yupResolver} from '@hookform/resolvers/yup';

import {SaveButton} from 'components';
import {useLayoutStore, useSnackbarStore} from 'store';

import {schema, useApiUpdate} from './useUserApi';

import {DateField, Form, FormField, useForm} from 'form';

const styles = {
    root: {
        background: theme => theme.palette.grey.darkest,
    },
    fieldContainer: {
        mb: 2
    },
};

const Data = ({user, onSave}) => {

    const setShowLoading = useLayoutStore((state) => state.setShowLoading);
    const showInfo = useSnackbarStore((state) => state.show);

    const {update, loading, data, errors} = useApiUpdate(user);

    console.log(data);

    const rhf = useForm(data, errors, true, {resolver: yupResolver(schema)});

    const doSave = () => {
        rhf.methods.handleSubmit(async formData => {
            try {
                const res = await update(formData);
                showInfo('user.action.save_success');
                if (res !== undefined) {
                    onSave(res);
                }
            } catch (e) {
                showInfo(e.message, {severity: 'warning'});
            }
        })();
    };

    useEffect(() => {
        setShowLoading(loading);
        return () => {
            setShowLoading(false);
        };
    }, [loading, setShowLoading]);

    return (
        <Stack sx={styles.root} direction="column" justifyContent="space-between">
            <Form methods={rhf.methods}>
                <Stack direction="column" justifyContent="flex-end" p={2}>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="firstname"
                            label="global.person.firstname"
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="lastname"
                            label="global.person.lastname"
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <DateField
                            name="birthday"
                            label="user.birthday"
                            disableFuture={true}
                            slotProps={{
                                actionBar: {
                                    actions: ['clear', 'accept', 'cancel'],
                                },
                            }}
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="number"
                            label="team.player.back_number"
                            type="number"
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="body.height"
                            label="user.body.height"
                            type="number"
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="body.weight"
                            label="user.body.weight"
                            type="number"
                        />
                    </Stack>

                    <SaveButton action={doSave} />

                </Stack>
            </Form>
        </Stack>
    );
};

export default Data;